module.exports = "\n.terraineditor {\n  width:100vw;\n  height:100vh;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.map {\n  -webkit-box-flex: 3;\n      -ms-flex: 3;\n          flex: 3;\n  background-color:blue;\n}\n\n.panel {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  border-left:1px solid #000;\n  padding:30px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/terraineditor/terraineditor.component.css
// module id = ./src/app/terraineditor/terraineditor.component.css
// module chunks = main